<template></template>
<script>
import { PermissionCode } from "@/models/enums/PermissionCodeEnum.js";
import { SubSystemCode } from "@/models/enums/SubSystemCode.js";
export default {
  data() {
    return {
      roleDefaut: {},
    };
  },
  methods: {
    /**
     * Hàm check quyền người dùng có thao tác được chức năng hay không
     * Cretead by HCPHI (15.09.2021)
     */
    checkPermission(
      features,
      actions,
      me,
      showWarn = true,
      listRoleData = null,
      isCallFromMain = false
    ) {
      var isPermission = true;
      // if (features) {
      //   let listRole = null;
      //   if (isCallFromMain) {
      //     listRole = listRoleData;
      //   } else {
      //     listRole = me.$store.getters.getListRole;
      //   }
      //   // ! Nếu không lấy được ở store thì phải lấy ở storage.
      //   // ! Một số trường hợp k lấy được ở store k rõ nguyên nhân nên phải dùng cách này
      //   if (!listRole && localStorage.getItem("PROCESS_Permission")) {
      //     listRole = JSON.parse(localStorage.getItem("PROCESS_Permission"));
      //   }

      //   if (listRole) {
      //     listRole.forEach((listRoleDetail) => {
      //       if (!listRoleDetail) {
      //         return false;
      //       }
      //       // * Nếu không có quyền hoặc Subsytem không có quyền thì trả vê false
      //       if (!listRoleDetail.PermissionDetail) {
      //         return false;
      //       }

      //       if (listRoleDetail.PermissionDetail[features]) {
      //         const listPermission =
      //           listRoleDetail.PermissionDetail[features].split(";");

      //         // ? Quyền mà truyền vào để check
      //         const listPermissionInput = actions.split(";");

      //         // Biến đếm số quyền không thỏa mãn từ bộ quyền so với quyền trên server
      //         let countFalse = 0;
      //         if (listPermissionInput.length > 0) {
      //           listPermissionInput.forEach((permission) => {
      //             if (permission) {
      //               let tmpPermission = listPermission.find(
      //                 (e) => e.toLowerCase() === permission.toLowerCase()
      //               );
      //               if (!tmpPermission) {
      //                 countFalse++;
      //               }
      //             }
      //           });
      //         }

      //         // Nếu danh sách quyền lấy về từ server theo vai trò chứa danh sách quyền truyền vào từ directive
      //         // thì mặc định là có quyền
      //         if (countFalse === 0) {
      //           isPermission = true;
      //         }

      //         // Nếu quyền không thỏa mãn = số quyền truyền vào thì trả về false ngược lại thì true
      //         countFalse == (countFalse == listPermissionInput.length)
      //           ? false
      //           : true;

      //         if (
      //           countFalse === true ||
      //           listPermission[0] == PermissionCode.FullPermission
      //         ) {
      //           isPermission = true;
      //         }
      //       }

      //       // case xử lí riêng cho trường hợp bấm vào setting
      //       // chỉ cần có 1 trong các quyền vào vai trò, người dùng, mẫu email...  thì đều vào được
      //       // DNCuong(12/09/2021)
      //       if (features == SubSystemCode.Setting) {
      //         if (
      //           listRoleDetail.PermissionDetail[SubSystemCode.Role] ||
      //           listRoleDetail.PermissionDetail[SubSystemCode.User] ||
      //           listRoleDetail.PermissionDetail[SubSystemCode.EmailTemplate] ||
      //           listRoleDetail.PermissionDetail[SubSystemCode.PrintTemplate] ||
      //           listRoleDetail.PermissionDetail[SubSystemCode.Connect] ||
      //           listRoleDetail.PermissionDetail[SubSystemCode.UserGroup]
      //         ) {
      //           isPermission = true;
      //         }
      //       }

      //       if (features == SubSystemCode.Request) {
      //         if (
      //           listRoleDetail.PermissionDetail[SubSystemCode.MyRequest] ||
      //           listRoleDetail.PermissionDetail[SubSystemCode.OtherRequest]
      //         ) {
      //           isPermission = true;
      //         }
      //       }
      //     });
      //   }
      //   if (showWarn && !isPermission) {
      //     me.$notify._error(me.$t("i18nCommon.NoPermission"));
      //   }
      // }
      return isPermission;
    },
    /**
     * lấy ra danh sách MISACode đơn vị cha có quyền chức năng hiện tại
     * Created by cvcuong1 - 19/7/2021
     */
    getMISACodeParenttAction(store, features, actions) {
      let listRole = store.getters.getListRole;
      var listMISACodeParent = [];
      listRole &&
        listRole.forEach((listRoleDetail) => {
          if (
            listRoleDetail &&
            listRoleDetail.PermissionDetail &&
            listRoleDetail.PermissionDetail[features] &&
            listRoleDetail.PermissionDetail[features].includes(actions)
          ) {
            listMISACodeParent.push(listRoleDetail.MISACode);
          }
        });
      return listMISACodeParent;
    },
    /**
     * Hàm check guard từng router
     * @param {*} to
     * @param {*} from
     * @param {*} next
     * HCPHI (15.09.2021)
     */
    guardRoute(
      to,
      from,
      next,
      subsytem,
      listPermission,
      me,
      listRequestPermission = null
    ) {
      if (
        this.checkPermission(
          subsytem,
          listPermission,
          me,
          false,
          listRequestPermission,
          true
        )
      ) {
        // console.log(subsytem);
        // console.log(listPermission);
        // console.log(listRequestPermission);
        next();
      } else {
        this.$PlatformFunction.show403();
        next(false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
